<template>
    <div id="landing">
        <div class="landing-bg one"></div>
        <div class="landing-bg two"></div>
        <vue-particles
            :move-speed="0.5"
            :particle-opacity="0.3"
            :hover-effect="false"
            :click-effect="false"
            color="#dedede"
        ></vue-particles>
        <div class="action">
            <h1 class="title is-1">Spydify</h1>
            <h2 class="subtitle">Visualise your Spotify tastes!</h2>
            <button
                class="button is-primary is-rounded"
                :class="{ 'is-loading': loading }"
                @click="login()"
            >
                Log in with Spotify
            </button>
            <hr />
            <button class="button is-primary is-rounded" @click="goToAbout()">
                About Spydify
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "Landing",
    data() {
        return {
            loading: false
        };
    },
    methods: {
        login() {
            this.loading = true;
            // Go to the dashboard
            this.$router.push("/dashboard");
        },
        goToAbout() {
            this.loading = true;
            this.$router.push("/about");
        }
    }
};
</script>

<style lang="scss">
#landing {
    height: 100vh;
}

.action {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;

    & .button {
        font-weight: bold;
    }

    & .subtitle {
        margin-bottom: 0.5rem !important;
    }
}

#particles-js {
    width: 100%;
    height: 100%;
    position: absolute;
}

.landing-bg {
    width: 100%;
    height: 100%;
    position: absolute;

    &.one {
        background-image: linear-gradient(90deg, #c074b2, #8ab5e8);
    }

    &.two {
        background-image: linear-gradient(transparent, #000);
    }
}
</style>
